<template>
  <div class="put_map">
    <div class="p-title">地图投放</div>
    <div :class="{'p-main':true, 'init': isInit}">
      <div v-show="!isConfirm" class="schedule_box">
        <TopStat v-if="isInit" />
        <template v-else>
          <div class="search_top">
            <div>筛选条件<span class="light_tip">通过筛选条件筛选适合的点位吧~</span></div>
            <div class="imp_box">
              <ExportFeatures v-if="!manualDraw" @upSus="importUploadSuccess" @exportResult="handleExport" />
              <div class="back_btn" @click="topBack"><i class="el-icon-arrow-left"></i>返回</div>
            </div>
          </div>
          <SearchCondition @search="searchCommunity" @reset="resetSearch" />
        </template>
        <div :class="{'map_area':true, 'is_init': isInit}">
          <RegionMap
            ref="mapRef"
            :init="isInit"
            :nbhdSearchFn="mapSearchSchedule"
            @chooseCity="onSelectCity"
            @backInit="() => { isInit = true }"
            @search="searchCommunity">
          </RegionMap>
          <div v-if="!isInit" class="nbhd_list">
            <CommunityList ref="listRef" @confirm="data => { confirmData = data; isConfirm = true; }" />
          </div>
        </div>
      </div>
      <OrderConfirm v-if="isConfirm" :options="confirmData" @confirmBack="onBackToSearch" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import TopStat from './mapPut/mapTopData'
// import RegionMap from './mapPut/MapComp'
import TopStat from './mapPut/TopStat'
import RegionMap from './mapPut/RegionMap'
import { deepClone } from '@/utils/functions'
import searchLabelsMix from '@/utils/searchLabelsMix'
import searchPointMix from '@/utils/mixins/searchPointMix'
import { geoLocation, GeoUtil } from '@/utils/AMapUtil'
export default {
  name: 'PutOrderMap',
  components: {
    TopStat,
    RegionMap,
    ExportFeatures: () => import('./mapPut/ExportFeatures'),
    SearchCondition: () => import('./mapPut/SearchCondition'),
    CommunityList: () => import('./mapPut/CommunityList'),
    OrderConfirm: () => import('@/views/order/OrderConfirm')
  },
  mixins: [searchLabelsMix, searchPointMix],
  data() {
    return {
      isInit: true,
      listSearchOpts: {},
      isConfirm: false,
      confirmData: {},
      searchParams: null
    }
  },
  computed: {
    ...mapState({
      mapZoom: state => state.bmap.mapZoom,
      focusPoint: state => state.bmap.focusPoint, // 搜索到的目标点
      zoomData: state => state.bmap.mapZoomData,
      allTimeRanges: state => state.bmap.allTimeRanges,
      isInitRequest: state => state.bmap.isInitResquest,
      isOperateReset: state => state.bmap.isOperateReset,
      manualDraw: state => state.bmap.manualDraw, // 绘制模式
      searchOptSenior: state => state.bmap.mapSearchOptionsSenior
    })
  },
  beforeDestroy() {
    delete window._nbhds
    this.$root.$off('searchChangePoint')
    this.initStoreData() // 初始化 store 数据
  },
  mounted() {
    // 关键字搜索选择POI地点之后请求
    this.$root.$on('searchChangePoint', this.searchCommunity)
    //在页面初始化的时候，加载下禁播标签
    this.$store.dispatch('getDictItemList', 'NEW_NO_PLAY_LABLE')//预加载新禁播标签
  },
  methods: {
    onBackToSearch() {
      this.isConfirm = false
      this.$refs.mapRef?.freshMapPointLabel()
    },
    onSelectCity(_city) {
      this.isInit = false
    },
    importUploadSuccess(data, type) {
      console.log('importUploadSuccess', data, type)
      this.searchCommunity()
    },
    resetSeniorData() { // 重置高级搜索数据
      console.log(this.zoomData.city)
      this.$store.commit('setManualDraw', false)
      this.$store.commit('setOptionSenior', { areaValue: 9, city: '', keyWord: '' })
      // this.$store.commit('setOptionSenior', { areaValue: 9, city: this.zoomData.city, keyWord: '' })
      this.$store.commit('setAdvancedFilter', { screenNum: '', recommendData: '', mediaTypes: [] })
      this.$store.commit('setExportPointData', {})
    },
    resetSearch() {
      this.resetSeniorData()
      this.searchCommunity(true)
    },
    topBack() {
      this.$root.$emit('mapListSpreadClose')
      this.$confirm('确认返回上一级重选?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleBack()
      }).catch(() => {})
    },
    handleBack() {
      this.$store.commit('setInitRequest', true)
      const zoomArea = this.zoomData
      // 以下if语句顺序不可调整,必须按区/县、城市、省份的顺序依次判断
      if (zoomArea.dist) {
        this.$refs.mapRef?.renderOrSearch(zoomArea.city)
        this.$store.commit('setZoomData', { ...deepClone(zoomArea), dist: null })
      } else if (zoomArea.city) {
        this.$refs.mapRef?.renderOrSearch(zoomArea.province)
        this.$store.commit('setZoomData', { ...deepClone(zoomArea), city: null })
        this.isInit = true
        this.initStoreData()
      } else if (zoomArea.province) {
        this.$refs.mapRef?.initData()
        this.$store.commit('setZoomData', { ...deepClone(zoomArea), province: null })
      }
    },
    initStoreData() {
      this.resetSeniorData() // 高级搜索区域数据重置
      this.$store.commit('setStoreData', {
        key: 'mapSearchOptions', value: {
          time: [ // 默认后天开始一周的时间范围
            new Date(+ new Date() + 2 * 24 * 3600000).format().slice(0, 10),
            new Date(+ new Date() + 9 * 24 * 3600000).format().slice(0, 10)
          ],
          age: [], sex: [], income: [], distType: [], contentTime: ''
        }
      })

      this.resetSearchStoreCommon()

      this.$store.commit('setFocusPoint', '')
      // 导入小区/连锁店
      this.$store.commit('setImportNbhdList', [])
      this.$store.commit('setImportPointList', [])
      this.$store.commit('setImportPointData', {})

      this.$store.commit('setInitRequest', true)
      this.searchParams = null
    },
    async getRecommandTimeSlots() {
      let allTimeRanges = this.$store.state.bmap.allTimeRanges
      if (!allTimeRanges || allTimeRanges.length == 0) {
        await this.$store.dispatch('getTimeRanges')
        allTimeRanges = this.$store.state.bmap.allTimeRanges
      }
      let recommendTimeSlotData = this.$store.state.bmap.recommendTimeSlotData
      if (recommendTimeSlotData && recommendTimeSlotData.length > 0) {
        let ids = allTimeRanges.map(el => el.guid)
        return recommendTimeSlotData.map(el => {
          let idx = ids.indexOf(el.frequencyTime)
          if (idx > -1) el.frequencyName = allTimeRanges[idx].frequencyName
          else el.frequencyName = ''
          return el
        })
      } else return []
    },
    getAddressCodesParams(boolean = false) {
      const seniorCityGuid = this.searchOptSenior.city
      console.log(this.$store.state.bmap.mapCityList,seniorCityGuid,this.zoomData)
      if (!seniorCityGuid) {
        // 全国判断重置还是查询，默认重置？
        return boolean?[this.zoomData.city.districtCode]:null
      } else {
        // 非全国下的逻辑
        return [this.$store.state.bmap.mapCityList.filter(el => el.guid == seniorCityGuid)[0].dicCode]
      }
    },
    getFrequencysParams() {
      return this.$store.state.bmap.chooseTimeSlot.data || []
    },
    getLabelDetailsV1(form) {
      let labelDetails = this.$store.state.order.labelDetails
      let labelList = []
        ;['age', 'distType', 'income', 'sex'].forEach(el => {
          let data = {}
          data[labelDetails[el][0].code] = form[el]
          labelList.push(data)
        })
      return labelList
    },
    /**
     *
     * @param boolean false 为重置
     */
    searchCommunity(boolean ) {
      console.log('searchCommunity',boolean)
      if (this.isOperateReset) { // 重置操作返回初始选择的城市
        const zcity = this.zoomData.city
        this.$store.commit('setFocusPoint', '')
        this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: [] })
        this.mapSearchSchedule({ lng: zcity.lon, lat: zcity.lat },false,true)
        this.$root.$emit('operateResetSetCity', zcity.districtCode - 0)
        return
      }
      const fp = this.focusPoint
      if (fp && fp.location) {
        this.mapSearchSchedule(fp.location,false,boolean)
      } else {
        this.getCurCityPoint(p => {
          if (p) {
            this.mapSearchSchedule(p,false,boolean)
          }
        })
      }
    },
    async mapSearchSchedule(point, penDrawOpt,boolean) {
      this.$root.$emit('mapSearchStart')

      const mapStore = this.$store.state.bmap
      let isImport = mapStore.mapImportPointSearchList.length > 0 || mapStore.mapImportNbhdSearchList.length > 0 // 是否是导入搜索
      let importNbhd = isImport && mapStore.mapImportNbhdSearchList.length // 是否是导入小区

      this.$store.commit('setFocusPoint', { location: point })

      let form = this.$store.state.bmap.mapSearchOptions
      this.listSearchOpts = form
      if (!form.contentTime) return this.messageTip('请选择购买时长')
      if (!form.time || form.time.length == 0) return this.messageTip('请选择投放时间')
      let addressCodes =  this.getAddressCodesParams(boolean)

      let reqParam = {
        addressCodes,
        contentTime: form.contentTime,
        displayRegion: form.displayRegion,
        noPlayingLabels: form.noPlayingLabels,
        selectSlotRequest: {
          endDate: form.time.length > 0 ? form.time[1] : '',
          frequencyList: this.getFrequencysParams(),
          startDate: form.time.length > 0 ? form.time[0] : '',
        },
        timeSegmentType: this.$store.state.bmap.chooseTimeSlot.idx
      }

      // labelList persons 相关参数处理（导入小区/连锁店不传）
      if (!isImport) {
        // 标签相关参数从 label store operate 中获取
        let { labels, persons } = this.$store.state.label.operate
        reqParam.nbhdLabels = labels // 收人水平 社区类型
        reqParam.personsLabels = persons
      }

      this.searchParams = reqParam

      // 先清空数据
      this.$store.commit('setSearchDetail', [])

      let round = this.searchOptSenior.areaValue

      let url = ''
      let loading = this.$loading({ target: '.p-main' })
      if (isImport) { // 导入搜索
        if (!importNbhd) { // 导入连锁店
          reqParam.pointList = mapStore.mapImportPointSearchList.map(el => {
            if (round) el.round = round * 1000
            return el
          })
          url = '/boss/deviceSlot/v2/importSearch'
        } else { // 导入小区
          url = '/boss/deviceSlot/v2/getIntelligentDeviceByExcel'
          reqParam.nbhdSearchMapResponse = {
            nbhdSearchList: mapStore.mapImportNbhdSearchList
          }
        }
      } else {
        url = '/boss/deviceSlot/v2/getAllDevice300Map'
        reqParam.coordinateType = 2 // 坐标类型(1:百度 2:高德)
        if (penDrawOpt) {
          reqParam.lon = penDrawOpt.lon + ''
          reqParam.lat = penDrawOpt.lat + ''
          reqParam.round = penDrawOpt.round
        } else {
          reqParam.lon = point.lng + ''
          reqParam.lat = point.lat + ''
          if (round) reqParam.round = round * 1000 // 投放搜索范围单位转为“米”
        }
      }
      // 地图投放收费方式统一设置为"CPD收费" lzd-20231220 确认订单也得加(由后端统一处理)
      // reqParam.orderLabels = ['L1']

      const res = await this.fetch(url, reqParam)
      loading.close()

      if (this.isInitRequest) { // 控制初始化时  多个参数初始化数据触发多次请求
        this.$store.commit('setInitRequest', false)
      }
      if (this.isOperateReset) { // 控制重置时  多个参数初始化数据触发多次请求
        this.$store.commit('setReset', false)
      }
      this.$store.commit('setAdvancedFilter', { screenNum: '', recommendData: '', mediaTypes: [] })
      if (res && res.code == 0) {
        if (res.data.scheduleMessage !== null) {
          const confirmFlag = await this.$confirm(res.data.scheduleMessage, '排期校验', {
            confirmButtonText: '继续投放',
            cancelButtonText: '取消'
          }).then(res => {
            return true
          }).catch(err => {
            return false
          })
          if(!confirmFlag) return
        }
        // 改变store labels 用户画像 等数据
        if (!isImport) {
          let { labels, persons, personsData } = this.$store.state.label.operate
          this.$store.commit('label/setStore', { key: ['confirm', 'labels'], value: labels })
          this.$store.commit('label/setStore', { key: ['confirm', 'persons'], value: persons })
          this.$store.commit('label/setStore', { key: ['confirm', 'personsData'], value: personsData })
        }

        if (!res.data) {
          this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: [] })
        }
        const result = res.data || {}
        if (isImport) { // 导入搜索请求
          let impRes = { ...result, list: result.data || [] }
          // 如果是导入连锁店,导入成功、失败等数量信息从 mapImportPointSearchData 中取,导入小区在这里接口数据会直接返回
          if (!importNbhd) impRes = { ...impRes, ...mapStore.mapImportPointSearchData }
          this.$store.commit('setExportPointData', impRes)
        }
        const that = this
        if (!result || !result.data || !result.data.length) {
          this.$store.commit('setSearchDetail', [])
          // 暂无数据提示消息
          that.$refs.mapRef?.noneTip()
        } else {
          const posArr = result.data.map(d => {
            // 小区坐标转换(百度=>高德)
            const gcjPoint = GeoUtil.bd09ToGcj02(d.lon, d.lat)
            if (gcjPoint) {
              d.lon = gcjPoint.lng
              d.lat = gcjPoint.lat
            }
            return d
          })

          // ---- MOCK TEST ----
          // posArr.push(...mockNbhd(posArr[posArr.length - 1], 1500))
          // ---- MOCK TEST ----

          this.$store.commit('setSearchDetail', posArr)
        }
        // 处理推荐时段
        this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: result.frequencyList || [] })
        // 如果不是画圈选屏,则让地图适配小区数据
        if (!penDrawOpt) {
          const t = setTimeout(() => {
            clearTimeout(t)
            that.$refs.mapRef?.fitMapView()
          }, 240)
        }
        return result.data || []
      } else if (res.code === 900501) {
        this.messageTip(res.message)
      }
      return []
    },
    async getCurCityPoint(fn) {
      const seniorCityCode = this.searchOptSenior.city
      const zoomCity = this.zoomData.city
      // mapSearchOptionsSenior.city 存在值优先级更高
      if (seniorCityCode && seniorCityCode !== Number(zoomCity?.districtCode)) {
        // 如果 mapSearchOptionsSenior 存的城市和 mapZoomData 里的城市不一致，可能不存在坐标点，通过地理编码获取城市经纬度坐标
        const cityDto = this.$store.state.bmap.mapCityList.filter(x => x.guid == seniorCityCode)[0]
        if (cityDto) {
          // 小区列表状态下切换城市，优先使用接口返回的城市经纬度(基础资料),若没有则用逆地理编码获取城市经纬度
          if (cityDto.point) {
            const [ lng, lat ] = cityDto.point.split(',')
            const cityGeo = GeoUtil.bd09ToGcj02(lng, lat)
            fn(new AMap.LngLat(cityGeo.lng, cityGeo.lat))
          } else {
            const cityName = cityDto.districtValue
            const geo = await geoLocation(cityName)
            if (geo && geo.location) {
              const locate = geo.location
              fn(new AMap.LngLat(locate.lng, locate.lat))
            } else {
              this.messageTip('您选择的地址没有解析到结果！')
            }
          }
        }
      } else {
        // mapSearchOptionsSenior.city 为''或者和 mapZoomData 里的城市坐标点一样,直接用mapZoomData里的城市坐标
        if (zoomCity && zoomCity.lon) {
          fn(new AMap.LngLat(zoomCity.lon, zoomCity.lat))
        }
      }
    },
    // 导出搜索结果
    async handleExport() {
      if (!this.searchParams) return this.messageTip('请搜索点位信息')
      if (this.$refs.listRef) {
        const nbhdArray = this.$refs.listRef.list || []
        if (nbhdArray.length == 0) return this.messageTip('请先搜索点位信息')
        // 筛选出至少勾选了一个电梯的小区
        const nbhds = nbhdArray.filter(one => one.allDevices.filter(ele => ele.check).length > 0 || one.indeterminate)
        const guids = nbhds.map(x => x.guid)
        if (guids.length == 0) return this.messageTip('请勾选小区点位')
        const { contentTime, labelList, selectSlotRequest, displayRegion } = this.searchParams
        if (selectSlotRequest.frequencyList.length == 0) {
          selectSlotRequest.frequencyList = await this.getRecommandTimeSlots()
        }

        let nbhdGuid_deviceGuid_map = {} // 小区ID为键,当前小区勾选的电梯设置ID为值
        nbhds.forEach(dto => {
          nbhdGuid_deviceGuid_map[dto.guid] = dto.allDevices.filter(d => d.check).map(f => f.deviceGuid)
        })

        let pointList = this.$store.state.bmap.exportPointData.pointList || []
        let addressCodes = this.getAddressCodesParams()
        let { labels, persons } = this.$store.state.label.operate
        await this.$export('/boss/deviceSlot/v2/exportSearchResult', {
          addressCodes,
          contentTime,
          labelList,
          pointList,
          nbhdGuids: guids.join(','),
          nbhdGuid_deviceGuid_map,
          selectSlotRequest,
          h5: false,
          wifi: false,
          nbhdLabels: labels,
          personsLabels: persons,
          displayRegion
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.put_map {
  height: 100%;
  .p-main {
    width: 100%;
    padding: 0 20px;
    overflow: visible;
    height: calc(100% - 80px);
    &.init {
      margin-top: 50px;
      height: calc(100% - 130px);
    }
    .schedule_box {
      width: 100%;
      height: 100%;
    }
  }
  .search_top {
    font-size: 18px;
    line-height: 30px;
    padding-top: 20px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    .light_tip {
      color: #999;
      font-size: 14px;
      margin-left: 10px;
    }
    .imp_box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .back_btn {
      cursor: pointer;
      width: 80px;
      height: 30px;
      line-height: 28px;
      font-size: 14px;
      color: #FF3973;
      border: 1px solid #FF3973;
      border-radius: 4px;
      text-align: center;
      .el-icon-arrow-left {
        font-weight: bold;
      }
    }
  }

  .map_area {
    position: relative;
    width: 100%;
    height: calc(100% - 116px);
    overflow: hidden;
    z-index: 2;
    &.is_init {
      height: calc(100% - 70px);
    }
    .nbhd_list {
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      background: #fff;
      z-index: 210; // 需大于200(.map_features_container)
    }
  }


  #map {
    width: 100%;
    height: 100%;
    border-radius: 10px 10px 0 0;
  }
}
</style>
